/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import dynamic from 'next/dynamic';
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';

// MI-COMMON-STATIC-COMPONENTS
import { EditableHTLWrapper } from '../../libs/mi-common-static-components/src/organisms/EditableHTLWrapper';
import { StaticWrapper } from '../../libs/mi-common-static-components/src/organisms/StaticWrapper';

// MI-PPV5-COMPONENTS
import { LocalHeaderEditable } from '../../libs/mi-ppv5-components/src/organisms/LocalHeader';
import { InternetBarEditable } from '../../libs/mi-ppv5-components/src/organisms/InternetBar';

// DYNAMIC IMPORTS - PPV5
const HeroBannerEditable = dynamic(() =>
  import('../../libs/mi-ppv5-components/src/organisms/HeroBanner').then(mod => mod.HeroBannerEditable)
);

const PropertyPortalContainerEditable = dynamic(() =>
  import('../../libs/mi-ppv5-components/src/organisms/PropertyPortalContainer').then(
    mod => mod.PropertyPortalContainerEditable
  )
);

const LocalServicesEditable = dynamic(() =>
  import('../../libs/mi-ppv5-components/src/organisms/LocalServices').then(mod => mod.LocalServicesEditable)
);

const Footer = dynamic(() =>
  import('../../libs/mi-common-static-components/src/molecules/Footer').then(mod => mod.Footer)
);

const ConnectContainerEditable = dynamic(() =>
  import('../../libs/mi-ppv5-components/src/organisms/ConnectContainer').then(mod => mod.ConnectContainerEditable)
);

const LetsConnectEditable = dynamic(() =>
  import('../../libs/mi-ppv5-components/src/organisms/LetsConnect').then(mod => mod.LetsConnectEditable)
);

const RTEEditable = dynamic(() =>
  import('../../libs/mi-ppv5-components/src/organisms/RTE').then(mod => mod.RTEEditable)
);

const BonvoyApplicationAdEditable = dynamic(() =>
  import('../../libs/mi-ppv5-components/src/organisms/BonvoyApplicationAd').then(mod => mod.BonvoyApplicationAdEditable)
);

// DYNAMIC IMPORTS - MERCHANDISING
const MerchandisingSmallBanner = dynamic(() =>
  import('../../libs/mi-merch-components/src/organisms/MerchandisingSmallBanner').then(
    mod => mod.MerchandisingSmallBanner
  )
);

export const AEM_REACT_MAPPING = {
  [`nt:unstructured`]: EditableHTLWrapper,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  ['mi-aem-ppv5-spa/components/content/experiencefragment']: Container,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
  [`mi-aem-ppv5-spa/components/content/localheader`]: LocalHeaderEditable,
  [`mi-aem-ppv5-spa/components/content/hero-banner`]: HeroBannerEditable,
  [`mi-aem-ppv5-spa/components/content/internet-box`]: InternetBarEditable,
  [`mi-aem-ppv5-spa/components/content/brandedcontainer`]: PropertyPortalContainerEditable,
  [`mi-aem-ppv5-spa/components/content/services-carousel`]: LocalServicesEditable,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,
  [`mi-aem-ppv5-spa/components/common/staticwrapper`]: ConnectContainerEditable,
  [`mi-aem-ppv5-spa/components/content/lets-connect-modal`]: LetsConnectEditable,
  [`mi-aem-ppv5-spa/components/content/ppv5-rte`]: RTEEditable,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: BonvoyApplicationAdEditable,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
};

export const definePreconnectComponentMapping = (allowedComponents, isAuthorMode, pageProps, ppv5CarouselFeatureFlags) => {
  const { carousel_switch_ppv5 = false } = ppv5CarouselFeatureFlags;
  const ppv5CarouselFromLightning =
    (pageProps?.query?.lightning === 'true' || carousel_switch_ppv5 === true) &&
    !pageProps?.requestUri?.includes('/preview');

  // Fallback for nt:unstructured (JCR type in responsive breakpoints, etc.) - only referenced in author mode
  MapTo(`nt:unstructured`)(EditableHTLWrapper, {
    emptyLabel: 'Unstructured',
    isEmpty: true,
  });

  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
    emptyLabel: 'StaticWrapper',
    isEmpty: false,
  });

  MapTo(`mi-aem-ppv5-spa/components/content/localheader`)(
    props => <LocalHeaderEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LocalHeader',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/hero-banner`)(
    props => <HeroBannerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'HeroBanner',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/internet-box`)(
    props => <InternetBarEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'InternetBarComponent',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/brandedcontainer`)(
    props => (
      <PropertyPortalContainerEditable {...props} isAuthorMode={isAuthorMode} isLightning={ppv5CarouselFromLightning} />
    ),
    {
      emptyLabel: 'PropertyPortalContainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/services-carousel`)(
    props => <LocalServicesEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'services_carousel',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(
    props => <Footer {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Footer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/common/staticwrapper`)(
    props => <ConnectContainerEditable {...props} isAuthorMode={isAuthorMode} readyToMount={false} />,
    {
      emptyLabel: 'ConnectContainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/lets-connect-modal`)(
    props => <LetsConnectEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'letsConnect',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/ppv5-rte`)(
    props => <RTEEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'RTEComponent',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
    props => <BonvoyApplicationAdEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'BonvoyApplicationAdComponent',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
    props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MerchandesingSmallBanner',
      isEmpty: false,
    }
  );

  const ExperienceFragmentVariationConfig = {
    emptyLabel: 'Experience Fragment',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };

  MapTo(`mi-aem-ppv5-spa/components/content/experiencefragment`)(props => {
    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={respGridUtil(props?.model)}
        isLightning={ppv5CarouselFromLightning}
      />
    );
  }, ExperienceFragmentVariationConfig);

  const DataPageVariationConfig = {
    emptyLabel: 'Data Page',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};